<template>
  <div class="information-detail">
    <div v-html="info.content" @click="prviewPhoto"></div>
  </div>
</template>
<script>
import {getBannerInfo} from '@/apis/banner'
import {getJsAPI} from '@/apis/weixin'
import wxapi from '@/utils/wxapi'
import { ImagePreview } from 'vant';
export default {
  name:'information',
  data(){
    return {
      info:{},
      shareData:{},
      shareOption:{}
    }
  },
  mounted(){
    this._getBannerInfo()
  },
  methods:{
    _getBannerInfo(){
      let params = {
        id:this.$route.query.id || null
      }
      getBannerInfo(params).then(res=>{
        this.info = res.data
        this.shareOption = {
          title:res.data.name,
          link:window.location.href,
          imgUrl:res.data.pic,
          desc:'台铃电动车，省电·跑更远！'
        }
        this._getJsAPI()
      })
    },
    _getJsAPI(){
      let params = {
        url:window.location.href
      }
      getJsAPI(params).then(res=>{
        this.shareData = res.data
        wxapi.wxRegister(this.shareData,this.shareOption)
      })
    },
    prviewPhoto(event){
      if(event.target.nodeName === 'IMG'){
        ImagePreview([event.target.src])
      }
    }
  }
}
</script>

<style>
  .information-detail{
    font-size: 15px;
    line-height:1.2;
    padding:8px;
    margin:0 auto;
    width:100%;
    min-width:320px;
    max-width:680px;
    box-sizing:border-box;
    text-align:left;
  }
  p{
    margin: 0px; 
    border:0px ; 
    padding: 0px;
  }
  img, video {
    width: 100% !important;
    height: auto !important;
    display: block;
  }
  .title{
    color: #4c4c4c;
    font-size: 20px;
    font-weight:bold;
    margin-bottom:1.6em;
    line-height:1.6;
  }
  .release-time{
    color:rgba(0,0,0,0.3);
    font-size:16px;
    margin-bottom:1em;
  }
</style>